import { Trans, useTranslation } from 'react-i18next';
import { Hint, HelpHintComponent } from '@myriadgenetics/mgh-types';
import './index.scss';

interface Props {
  compDef: any | HelpHintComponent;
}

const toKebabCase = (str: string): string => {
  if (str.includes(' ')) {
    return str.toLowerCase().split(' ').join('-');
  }
  return str.toLowerCase();
};

function HelpHint({ compDef }: Props) {
  const { t } = useTranslation();
  const { helpHint, hintSeparator }: { helpHint: Hint; hintSeparator: string } = compDef.data;
  const HINT_SEPARATOR = helpHint.termKey === '' ? '' : hintSeparator || ':';
  return (
    <p className="help-hint" data-testid={`help-hint-${toKebabCase(t(helpHint.termKey))}`}>
      {helpHint.definitionKey ? (
        <>
          <span className="help-hint__term text-medium--semi-bold">
            <Trans i18nKey={helpHint.termKey} />
          </span>
          {HINT_SEPARATOR.length !== 0 && <span className="help-hint__separator text-medium--semi-bold">{HINT_SEPARATOR}&nbsp;</span>}
        </>
      ) : (
        <>
          <span className="help-hint__term text-medium--regular">
            <Trans i18nKey={helpHint.termKey} />
          </span>
        </>
      )}
      {helpHint.definitionKey && (
        <span className="help-hint__definition text-medium--regular">
          <Trans i18nKey={helpHint.definitionKey} />
        </span>
      )}
    </p>
  );
}

export default HelpHint;
